import Card from "./Card";
import { Box, Typography } from "@mui/material";
import { COLORS } from "../../../dashboard/epis-dashboard/configs/config";



export default function CardEquipamentosPorTipo({ tipos = [], loading }) {

    function StackedBar({ partes, total }) {
        return (
            <Box sx={{ display: "flex", height: 12, borderRadius: 6, overflow: "hidden", bgcolor: COLORS.kpiBg }}>
                {partes.map((p) => (
                    <Box
                        key={p.label}
                        title={`${p.label}: ${fmt(p.valor)}`}
                        sx={{ width: `${total ? (p.valor / total) * 100 : 0}%`, bgcolor: p.cor, transition: "width .4s" }}
                    />
                ))}
            </Box>
        );
    }
    const fmt = (n) => (n ?? 0).toLocaleString("pt-BR");
    const totalAtivos = tipos.reduce((s, t) => s + t.ativos, 0);
    const totalInativos = tipos.reduce((s, t) => s + t.inativos, 0);
    return (
        <Card title="Equipamentos por tipo" subtitle={`${fmt(totalAtivos)} ativos · ${fmt(totalInativos)} inativos no total`} loading={loading}>
            {tipos.map((t) => {
                const total = t.ativos + t.inativos;
                return (
                    <Box key={t.tipo} sx={{ mb: 1.5 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                            <Typography variant="body2" sx={{ color: COLORS.tPri, fontWeight: 600 }}>{t.tipo}</Typography>
                            <Typography variant="caption" sx={{ color: COLORS.tDim }}>
                                {fmt(t.ativos)} ativos / {fmt(t.inativos)} inativos
                            </Typography>
                        </Box>
                        <StackedBar
                            total={total}
                            partes={[
                                { label: "Ativos", valor: t.ativos, cor: COLORS.g1 },
                                { label: "Inativos", valor: t.inativos, cor: COLORS.red },
                            ]}
                        />
                    </Box>
                );
            })}
        </Card>
    );
}
